import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { ConfigService } from '../../services/config/config.service';
import { TermsAndConditionsService } from '../../services/terms-and-conditions/terms-and-conditions.service';
import { VideoPortalUser } from '../../services/auth/video-portal-user.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
    productName: string;
    isIframe = false;
    currentUser: VideoPortalUser | null = null;
    private destroy$ = new Subject<void>();

    constructor(private authService: AuthService,
                private configService: ConfigService,
                private termsAndConditionsService: TermsAndConditionsService
                ) {
        this.productName = this.configService.config.productName;
    }

    ngOnInit(): void {
        this.authService.initMSAL();

        this.authService.userInfoSubject
            .pipe(takeUntil(this.destroy$))
            .subscribe(user => {
                this.currentUser = user;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get isLoginInProgress(): boolean {
        return this.authService.isLoginInProgress;
    }

    login(): void {
        this.authService.login();
    }

    logout(): void {
        this.authService.logout();
    }

    isLoggedIn(): boolean {
        return !!this.currentUser;
    }

    get mustAgree(): boolean {
        return this.termsAndConditionsService.canAgreeToTermsAndConditions && !!this.currentUser;
    }

    showTermsAndConditions(): void {
        this.termsAndConditionsService.show();
    }

    isInRole(role: string): boolean {
        return !!this.currentUser && this.currentUser.isInRole(role);
    }

    showUsageReports(): boolean {
        return !!this.currentUser &&
            this.currentUser.isInRole('jjr') && this.currentUser.hasAdminRole;
    }
}
